<header>
    <poll-show-header></poll-show-header>
</header>
<main>
    <div class="container">
        <router-outlet></router-outlet>
    </div>
</main>